module.exports = __webpack_public_path__ + "img/knowhow-2.30fcc8a.webp";